import { menuSelect } from 'instantsearch.js/es/widgets'
import {
  menuSelectItem,
  libraryMenuSelectClasses,
} from '../documentLibrary/tpl-menuSelect'

const widget = document.querySelector('[data-widget="taskGroup"]')
const label = widget == null ? 'See All' : widget.dataset.label
const taskGroup = widget == null ? false : menuSelect({
  container: "[data-widget='taskGroup']",
  attribute: 'Task Group',
  sortBy: ['name:asc'],
  cssClasses: libraryMenuSelectClasses,
  templates: {
    item: menuSelectItem,
    defaultOption: `<span class="hover:underline">${label}</span>`,
  },
})

export { taskGroup }
